/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: Facility Info DataTable
 * Description: Master Setup of Facility Info DataTable
 * Date: 15/03/2022
 */

import { useCallback, useEffect } from 'react';
import { Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import useDataTable from '../../../hooks/useDataTable';
import SweetAlertService from '../../../services/SweetAlertService';
import UrlService from '../../../services/UrlService';
import { useLayerChaining } from './ContextAPI';

export default function DataTable() {
    const { layerChain, getAllData, setRowData, setShow } = useLayerChaining();
    const { deleteSwal } = SweetAlertService();

    const dataList = useCallback(() => {
        getAllData();
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    const deleteHandler = (row) => {
        deleteSwal({
            id: row.id,
            url: UrlService.deleteLayerChainingUrl(),
            refreshList: getAllData,
            beforeTitle: 'Are you sure?',
            beforeText: "You won't be able to revert this!",
            afterTitle: 'Deleted!',
            afterText: 'Your file has been deleted.',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
    };

    const editHander = (row) => {
        setShow(true);
        setRowData(row);
    };

    const columns = [
        {
            name: 'Layer Name',
            selector: (row) => row.layer_name,
            sortable: true,
            cell: (row) =>
                row.layer_name == 'unhcr'
                    ? 'UNHCR'
                    : row.layer_name == 'center'
                        ? 'Center'
                        : row.layer_name == 'partner'
                            ? 'Partner'
                            : row.layer_name == 'facility'
                                ? 'Facility'
                                : '',
        },
        {
            name: 'Role Name',
            selector: (row) => row.role_name,
            sortable: true,
        },
        {
            name: 'Level',
            selector: (row) => row.level,
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row) => row.status,
            cell: (row) =>
                row.status == 1 ? (
                    <Badge className="badgeActive" bg="success">
                        Active
                    </Badge>
                ) : (
                    <Badge className="badgeInactive" bg="success">
                        Inactive
                    </Badge>
                ),
        },
        {
            name: 'Action',
            selector: (row) => row.action,
            cell: (row) => (
                <>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-edit-${row.id}`}>Edit</Tooltip>}
                    >
                        <Button
                            className="btn btn-light actionBtn"
                            variant="primary"
                            onClick={() => editHander(row)}
                        >
                            <i className="fas fa-edit" />
                        </Button>
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-del-${row.id}`}>Delete</Tooltip>}
                    >
                        <Button
                            onClick={() => {
                                deleteHandler(row);
                            }}
                            type="button"
                            className="btn btn-light actionBtn"
                        >
                            <i className="fas fa-trash-alt" />
                        </Button>
                    </OverlayTrigger>
                </>
            ),
        },
    ];

    const search_column = {
        name: 'Name',
        code_no: 'Code No',
        'partner.name': 'Partner',
    };
    return useDataTable({ columns, data: layerChain, search_column });
}
